// Permissão de Módulo (issue #71): cada tela decide se mostra os controles
// de escrita a partir desta única checagem — nunca replicada tela por tela.
// Só esconde; quem de fato recusa uma escrita fora do Módulo é o servidor
// (`server/acesso.ts`, mesma checagem).

import { podeGravarNoModulo } from "../../comandos/_acesso.ts";
import type { Modulo } from "../../domain/schema.ts";
import { euIdAtual } from "../api.ts";
import type { Store } from "../store.ts";

/**
 * O Perfil do usuário logado tem gravação neste Módulo? Sem sessão (modo
 * local, ou `eu` ainda não resolvido) é sempre `true` — acesso total, o
 * comportamento de sempre fora do modo hospedado.
 */
export function podeEditarModulo(store: Store, modulo: Modulo): boolean {
  const uid = euIdAtual();
  return uid == null || podeGravarNoModulo(store.get(), uid, modulo);
}
